import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router, Event, NavigationEnd } from '@angular/router';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { BaseComponentConfig, ViewContainersService, UpdateComponentStoreService, UbsComponentStoreService, ActionState, ComponentConfig, SelectedValue, Relation, CustomContainerItem } from '@urbannex/view-containers';
import { baseMenuItems,options } from '../configoptions';
import { OrderOverviewComponent } from '../order-overview/order-overview.component';
import { filter, map, Subject, takeUntil } from 'rxjs';
import { RemoteFormData } from '@urbannex/ofbiz-forms';


@Component({
  selector: 'ubs-sales-order',
  templateUrl: './sales-order.component.html',
  styleUrls: ['./sales-order.component.scss']
})
export class SalesOrderComponent extends BaseComponentConfig implements OnInit,OnDestroy{
  orderId:string;
  partyId:string
  selectedValue:SelectedValue;
  hasValue = false;
  isMenuSet = false;
  isContextMenu = false;
  defaultAction = ActionState.LIST;

  readonly menuItem$ = this.menuService.onItemClick().pipe(
    map(menuBag => menuBag)
  );

  readonly routeParams$ = this.route.paramMap.pipe(map(params => params));

  private destroy$ = new Subject<void>();
  /**
   * Type from menuItem data object used to resolve the master-detail/relation specified in the context menu
   */
  selectedValueType:string;

  routerEvents$ = this.router.events.pipe(
    takeUntil(this.destroy$),
    map(event => event)
  )

  path$ = this.router.events.pipe(
      filter((e: Event): e is Event=> e instanceof NavigationEnd),
      takeUntil(this.destroy$),
      map(e => e)
    );

  url: string; // = this.router.url;

  /**
   * A subMenuItem is a menu item that is a child of another menu item. For example, in a menu item called "Shipping", the subMenuItems might be "Delivery Schedule", "Shipment Information", "Create New Ship Group", and "Ship Group Items".
   */
  subMenuItem:string;

  @Output() contextMenuItems = new EventEmitter<NbMenuItem[]>()
  statusId: any;

  
  
  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService,
    private componentStore:UbsComponentStoreService) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
  
   this.routeParams$.subscribe(params => {
      console.log(params);
      if(params.get("orderId")){
        this.orderId = params.get("orderId");
      }
      if(params.get("statusId")){
        this.statusId = params.get("statusId");
        //console.log(this.statusId)
      }
      if(params.get("subMenuItem")){
        this.subMenuItem = params.get("subMenuItem");
      }
      if(params.get("partyId")){
        this.partyId = params.get("partyId");
      }
      if(params.get("event")){
        this.action = this.setActionStateFromParam(params.get("event"));
      }else{
        this.route.data.subscribe(data => {
          if(data.event){
            console.log("getting evet from route data",data.event);
            this.action = this.setActionStateFromParam(data.event);
            this.routerData = data;
          }
        });
      }
   });
   this.menuService.onItemClick().subscribe((event) => {
    if(event.tag != 'contextMenu'){
      if(event.item.data){
        let data = event.item.data;
        if(data.event){
          this.action = data.event;
          if(this.action == ActionState.LIST){
            console.log(options);
            options.listForm.findParameters = [];
            options.listForm.findParameters.push({"view_SALES_ORDER":"Y"});
            options.listForm.findParameters.push({"view_PURCHASE_ORDER":"N"});
            options.listForm.findParameters.push({"facilityId":"WebStoreWarehouse"});
            this.componentConfig = new ComponentConfig(options);
            /* this.componentConfig.listForm.findParameters.push({"view_SALES_ORDER":"Y"});
            this.componentConfig.listForm.findParameters.push({"view_PURCHASE_ORDER":"N"});
            this.componentConfig.listForm.findParameters.push({"facilityId":"WebStoreWarehouse"}); */
          }
          console.log(data,this.componentConfig.listForm);
        }
      }
    }else if(event.tag == 'contextMenu'){
      console.log("ContextMenuUpdate - ",this.componentConfig)
      if(event.item.data){
        let data = event.item.data;
        if(data.event){
          this.action = data.event;
          console.log("ContextMenuUpdate - ",this.action);
          this.selectedValueType = data.type?data.type:this.setSelectedValueType(this.action);
          console.log("ContextMenuUpdate - ",this.selectedValueType);
          if(this.action == ActionState.MASTERDETAIL || this.action == ActionState.RELATE){
            if(this.action == ActionState.MASTERDETAIL){
              //this.componentConfig.selectedMasterDetails = this.setSelectedRelation(this.action,this.selectedValueType);
              //this.componentConfig = {...this.componentConfig,selectedMasterDetails:this.setSelectedRelation(this.action,this.selectedValueType)}
              options.selectedMasterDetails = this.setSelectedRelation(this.action,this.selectedValueType);
              options.defaultAction = this.action;
              this.componentConfig = new ComponentConfig(options);
            }
            if(this.action == ActionState.RELATE){
              this.componentConfig.selectedRelation = this.setSelectedRelation(this.action,this.selectedValueType);
            }
            this.setListOption(this.action);
            this.createMenuItems(this.orderId);
            console.log("ContextMenuUpdate - ",this.componentConfig)
          }
        }
      }
    }
    });
    /* this.menuService.onItemClick().subscribe((event) => {
      if(event.tag == 'contextMenu'){
        if(event.item.data){
          let data = event.item.data;
          if(data.event){
            this.action = data.event;
            console.log(data);
          }
        }
      }
    }); */  
    this.route.paramMap.subscribe((params) => {
      if(params.get("orderId")){
        this.orderId = params.get("orderId");
        if(this.orderId != undefined){
          this.route.data.subscribe(data => {
            console.log(data);
            if(data.event){
              this.action = data.event;
              this.routerData = data;
            }
          })
          if(params.get("event")){
          }
          //this.createMenuItems(this.orderId);
          options.defaultAction =  ActionState.CUSTOM;
          //this.setSelectedValue(this.orderId);
          //this.createMenuItems(this.orderId);
        }
        this.hasValue = true;
      }
      
    })
    }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngOnInit(): void {
/*     this.routerEvents$.subscribe(
      (event: NavigationEvent) => {
        if(event instanceof NavigationStart) {
         console.log(event.url);
         this.url = event.url
        }
      }); */
      /**
     * Tracking route changes other than initial,navigation
     */
    this.path$.subscribe((_path:NavigationEnd) => {
      console.log("Getting a path ..."+_path.url);
    }) 
    console.log("Sales Order Called - ",this.action);
    this.viewContainerService.getSelectedRow().pipe(takeUntil(this.destroy$)).subscribe(data => {console.log(data)})
    console.log("OrderId",this.orderId,"StatusId",this.statusId,"Action",this.action);
    console.log(this.action);
    if(this.orderId != undefined){
      if(this.action != null && this.action != undefined){
        this.selectedValueType = this.setSelectedValueType(this.action);
        if(this.action == ActionState.MASTERDETAIL || this.action == ActionState.RELATE){
          if(this.action == ActionState.MASTERDETAIL){
            options.selectedMasterDetails = this.setSelectedRelation(this.action,this.selectedValueType);
          }
          if(this.action == ActionState.RELATE){
            options.selectedRelation = this.setSelectedRelation(this.action,this.selectedValueType);
          }
          this.setListOption(this.action);
        }
      }
      this.setSelectedValue(this.orderId);
      this.createMenuItems(this.orderId);
    }else{
      if(this.action == ActionState.LIST){
        console.log(options);
        options.listForm = options.listForm;
      }
    }

    options.breadCrumbData = {
      displayPrefix:"Product Feature Categories",
      addFormText:"Create Feature Category",
      editFormText:"Update Feature Category"
    }
    options.defaultAction =  this.action?this.action:this.defaultAction;
    if(options.listForm != undefined && options.listForm != null){
      options.listForm.findParameters.push({"view_SALES_ORDER":"Y"});
      options.listForm.findParameters.push({"view_PURCHASE_ORDER":"N"});
    }
    this.componentConfig = new ComponentConfig(options);

  }

  setSelectedValueType(action:ActionState):string{
    let url:string;
    console.log("ContextMenuUpdate - ",action,this.router.url)
    /* this.routerEvents$.subscribe(
      (event: NavigationEvent) => {
        if(event instanceof NavigationStart) {
         
         url = event.url
        }
      }); */
    console.log(url,this.router.url);
    let selectedValueType;
    switch (action) {
      case ActionState.CUSTOM:
        if (this.router.url.includes('order-overview')) {
          selectedValueType = "OrderOverView";
          options.customContainerItems = [new CustomContainerItem("OrderOverView", OrderOverviewComponent, {orderId:this.orderId})]
        /* } else if (this.url.includes('customer-info/contacts')) {
          selectedValueType = "OrderCustomer";
          options.customContainerItems = [new CustomContainerItem("OrderCustomer", OrderCustomerComponent, {orderId:this.orderId})] 
        } else if (this.url.includes('customer-info/history')) {
          selectedValueType = "OrderHistory";
          options.customContainerItems = [new CustomContainerItem("OrderHistory", OrderHistoryComponent, {orderId:"",partyId:this.partyId,facilityId:"WebStoreWarehouse"})]*/
        }
        break;
      case ActionState.MASTERDETAIL:
        if (this.router.url.includes('order-items')) {
          selectedValueType = "Update Order Items";
        } else if (this.router.url.includes('order-adjustments')) {
          selectedValueType = "Update Order Adjustments";
        } else if (this.router.url.includes('order-payments')) {
          selectedValueType = "Order Payment Preferences";
        } else if(this.router.url.includes('customer-info/contacts')){
          selectedValueType = "Customer Contact Information";
        } else if(this.router.url.includes('customer-info/history')){
          selectedValueType = "Customer Order History";
        } else if(this.router.url.includes('ship-groups')){
          selectedValueType = "Ship Group Items";
        }
        console.log("ContextMenuUpdate - ",selectedValueType,this.url)
        break;
      case ActionState.RELATE:
        if (this.router.url.includes('delivery-schedule')) {
          selectedValueType = "Order Delivery Schedule";
        }
        break;
      default:
        break;
    }
    return selectedValueType
  }

  setListOption(action:ActionState){
    switch (action) {
      case ActionState.MASTERDETAIL:
        options.listForm.findParameters = [];
        //options.listForm = this.selectedMasterDetail?.listForm?this.selectedMasterDetail.listForm:options.selectedMasterDetails.listForm;//options.masterDetails[0].listForm;
        //options.listForm.findParameters.push({"orderId":this.orderId});
        break;
      case ActionState.RELATE:
        //options.listForm = options.relations[0].listForm;
        break;
      default:
        options.listForm = options.listForm;
        break;
    }
  }
  setSelectedRelation(action,selectedValueType):Relation{
    console.log(selectedValueType)
    let selectedRelation;
    switch (action) {
      case ActionState.MASTERDETAIL:
        let masterDetails:any[] = options.masterDetails;
        masterDetails.forEach((masterDetail:Relation,i) => {
          console.log(masterDetail.title,selectedValueType);
          if(masterDetail.title == selectedValueType){
            selectedRelation = masterDetail;
            selectedRelation.listForm.findParameters = [];
            selectedRelation.listForm.findParameters.push({"orderId":this.orderId});
            if(selectedValueType == "Customer Order History"){
              selectedRelation.listForm.findParameters.push({"partyId":this.partyId});
              selectedRelation.listForm.findParameters.push({facilityId:"WebStoreWarehouse"});
              selectedRelation.listDetail.findParameters = [{orderId:this.orderId},{facilityId:"WebStoreWarehouse"}];
            }
            if(selectedValueType == "Ship Group Items"){
              selectedRelation.listDetail.findParameters = [{orderId:this.orderId},{shipGroupSeqId:""}];
            }
            if(selectedRelation.isDymanic){
              selectedRelation.dynamicAddForms.forEach(form => {
                form.breadCrumbData.data.parameters.orderId = this.orderId;
              })
            }
          }
          console.log(selectedRelation);
      })
        break;
      case ActionState.RELATE:
        let relations:any[] = options.relations;
        console.log(relations);
        let position:number;
        /* if(this.routerData == undefined || this.routerData == null){
          this.route.data.subscribe(data => {
            console.log(data);
            if(data.event){
              this.action = data.event;
              this.routerData = data;
            }
          })
        } */
        relations.forEach((relation:Relation,i) => {
            if(relation.title == selectedValueType){
              selectedRelation = relation;
              if(selectedRelation.addForm != undefined && selectedRelation.addForm != null){
                let breadCrumbData = selectedRelation.addForm.breadCrumbData;
                let remoteFormData:RemoteFormData = breadCrumbData.data;
                console.log(remoteFormData);
                if(remoteFormData && remoteFormData.parameters != undefined){
                  Object.keys(remoteFormData.parameters).forEach(key => {
                    if(key == "orderId"){
                      remoteFormData.parameters["orderId"] = this.orderId;
                    }
                    if(key == "partyId"){
                      remoteFormData.parameters["partyId"] = this.partyId;
                    }
                    if(key == "facilityId"){
                      remoteFormData.parameters["facilityId"] = "WebStoreWarehouse";
                    }
                  })
                }
              }
              position = i;
              console.log(selectedRelation,i)
            }
        })
        if(selectedRelation != undefined){
          //Move the selected relation to the top
          let reorderedRelations = this.reOrderRelations(relations,position);
          console.log(reorderedRelations);
          options.relations = reorderedRelations;
        }
        break;
      default:
        break;
    }
    return selectedRelation;
  }

  setSelectedValue(orderId:string){
    console.log(this.action);
    let selectedValue:SelectedValue = {
      event:this.action?this.action:ActionState.CUSTOM,
      type:this.selectedValueType?this.selectedValueType:"OrderOverView",
      label:"Sales Order",
      data:{
        formData: {
          formName: 'EditProductRest',
          formLocation: 'component://kwikstore/widget/ProductForms.xml',
        },
        parameters:{"orderId":orderId,"statusId":this.statusId}
      }

    }
    setTimeout(() =>{
      console.log(this.action)
      options.defaultAction = this.action?this.action:ActionState.CUSTOM;

      //this.componentStore.updateComponentConfig(this.componentConfig);
      //console.log(this.componentConfig);
      this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
      //this.hasValue=true;
    },500)
    
  }
  
  createMenuItems(orderId:string){
    let menuItems:NbMenuItem[] = [
      {
        title:"Order ["+orderId+"]",
        group:true,
      },
      {
        "title":"Order Overview",
        "link":'/admin/orders/sales/order/'+orderId+'/'+this.statusId+'/'+this.partyId+'/order-overview/custom',
        data:{
          event:ActionState.CUSTOM,
          type:"OrderOverview",
          data:{
          "formData":{
                "formName":"EditOrder",
                "formLocation":"component://kwikstore/widget/ProductForms.xml",
                "link":"/admin/orders/sales/order/${orderId}/${statusId}"
            },
          appContext:"catalog",
          }
        }
      },
      {
        "title":"Update Order Items",
        "link":'/admin/orders/sales/order/'+orderId+'/'+this.statusId+'/order-items/master-detail',
        data:{
          event:ActionState.MASTERDETAIL,
          type:"Order Items",
        }
      },
      {
        "title":"Update Order Adjustments",
        "link":'/admin/orders/sales/order/'+orderId+'/'+this.statusId+'/order-adjustments/master-detail',
        data:{
          event:ActionState.MASTERDETAIL,
          type:"Order Adujstments",
        }
      },
      {
        "title":"Payment Information",
        "link":'/admin/orders/sales/order/'+orderId+'/'+this.statusId+'/order-payments/master-detail',
        data:{
          event:ActionState.MASTERDETAIL,
          type:"Order Payment Preferences",
        }
      },
      {
        title:"Customer",
        children:[
          {
            "title":"Contact Information",
            "link":'/admin/orders/sales/order/'+orderId+'/'+this.partyId+'/customer-info/contacts/master-detail',
            data:{
              event:ActionState.MASTERDETAIL,
              type:"Customer Contact Information",
            }           
          },
          {
            "title":"Order History",
            "link":'/admin/orders/sales/order/'+orderId+'/'+this.partyId+'/customer-info/history/master-detail',
            data:{
              event:ActionState.MASTERDETAIL,
              type:"Customer Order History",
            }
          }
        ]
      },
      {
        title:"Shipping",
        children:[
          {
            "title":"Delivery Schedule",
            "link":'/admin/orders/sales/order/'+orderId+'/'+this.statusId+'/delivery-schedule/relate'
          },
          {
            "title":"Order Ship Groups",
            "link":'/admin/orders/sales/order/'+orderId+'/'+this.statusId+'/ship-groups/master-detail',
            data:{
              event:ActionState.MASTERDETAIL,
              type:"Ship Group Items"
            }
          },
          {
            "title":"Create New Ship Group",
            "link":'/admin/orders/order/'+orderId+'/costs'
          },
          {
            "title":"Ship Group Items",
            "link":'/admin/orders/order/'+orderId+'/agreements'
          }
        ]
      },
      {
        title:"Communications",
        "link":'/admin/orders/order/'+orderId+'/prices'
      },
      {
        title:"Notes",
        "link":'/admin/orders/order/'+orderId+'/facilities'
      }
    ]
    console.log("Adding menu items",menuItems)
    //this.menuService.addItems([],'productsMenu');
    //this.viewContainerService.contextMenu$.next(menuItems);
    //this.menuService.addItems(menuItems,'contextMenu');
    setTimeout(() =>{
      this.contextMenuItems.emit(menuItems)
    },1)
    
  }

}

/**
 * quickShipOrder
 * use-when: orderHeader.statusId == 'ORDER_APPROVED'|| orderHeader.statusId == 'ORDER_SENT'
 * executes service:quickShipEntireOrder
 * description:The quickShipEntireOrder service on Apache Ofbiz should be executed when the orderHeader.statusId is either 'ORDER_APPROVED' or 'ORDER_SENT'. This service quickly ships an entire order by creating one shipment per facility and ship group, automatically issuing all approved order items in full and putting them into one package. The shipment is created in the INPUT status and then updated to PACKED and SHIPPED, and the order status is updated to SENT.
 * input-parametes: orderHeader.orderId
 * 
 * An alternative to quickShipEntireOrder in Apache Ofbiz is the createShipment service. This service allows for more granular control over the shipment process, including creating shipments for specific order items, setting shipment dates, and managing multiple packages.

Here's a brief overview of how you might use createShipment:

Create Shipment: Use the createShipment service to create a new shipment record.
Add Items to Shipment: Use the addOrderItemShipGroupAssoc service to associate order items with the shipment.
Update Shipment Status: Use the updateShipment service to update the status of the shipment to PACKED and then SHIPPED.
This approach provides more flexibility compared to quickShipEntireOrder, which is designed for quickly shipping entire orders with minimal configuration.
 * 
 */
/**
 * OrderDeliveryScheduleInfo
 * use-when: orderHeader.statusId == 'ORDER_COMPLETED'|| orderHeader.statusId == 'ORDER_CANCELLED'
 * produces: UpdateDeliveryScheduleInformation location:component://order/widget/ordermgr/OrderDeliveryScheduleForms.xml
 * description: The UpdateDeliveryScheduleInformation form in Apache OfBiz is used to manage and update the delivery schedule information for an order. This form allows users to view and modify the delivery schedule details, such as delivery dates, times, and any special instructions related to the delivery of the order items. It is typically used when the order status is either ORDER_COMPLETED or ORDER_CANCELLED to ensure that the delivery information is accurate and up-to-date.
 */
/**
 * quickRefundOrder
 * use-when: orderHeader.statusId == 'ORDER_COMPLETED'
 */
/**
 * quickreturn
 * use-when: orderHeader.statusId == 'ORDER_COMPLETED' && hasReturnables
 * produces:component://order/template/return/QuickReturn.ftl
 */
/**
 * editOrderItems
 * use-when: orderHeader.statusId !== 'ORDER_CANCELLED'&& orderHeader.statusId !== 'ORDER_SENT' && orderHeader.statusId !== 'ORDER_COMPLETED' && orderHeader.statusId !== 'ORDER_REJECTED'
 */
/**
 * createOrderItemShipGroup
 * use-when: orderHeader.statusId !== 'ORDER_CANCELLED'&& orderHeader.statusId !== 'ORDER_SENT' && orderHeader.statusId !== 'ORDER_COMPLETED' && orderHeader.statusId !== 'ORDER_REJECTED'
 * executes service:addOrderItemShipGroup
 * description:The addOrderItemShipGroup service in Apache Ofbiz is used to create a new shipping group for an order. This service allows you to specify details such as the shipping address, shipping method, and the items that should be included in the new shipping group. It is typically used when you need to split an order into multiple shipments, each with its own shipping details.

Key Features:
Create New Shipping Group: Allows the creation of a new shipping group within an existing order.
Specify Shipping Details: Enables the specification of shipping address, method, and other relevant details.
Associate Order Items: Associates specific order items with the new shipping group.
Example Usage:
Splitting Shipments: When an order needs to be split into multiple shipments due to different shipping addresses or methods.
Partial Shipments: When only part of an order is ready to be shipped, and the rest will be shipped later.
This service provides flexibility in managing complex shipping requirements for orders.
 * 
 * 
 */
/**
 * quickReturnOrder
 * use-when: orderHeader.statusId == 'ORDER_COMPLETED' && hasReturnables
 * executes service:quickReturnOrder
 * description: The quickReturnOrder service in Apache Ofbiz is used to quickly process the return of an entire order. This service is typically executed when the order status is ORDER_COMPLETED and there are returnable items in the order.
 * Purpose:
Process Returns: Quickly processes the return of all items in an order.
Automate Return Handling: Automates the creation of return records and updates the order status accordingly.
Requirements to Execute:
Order Status: The order status must be ORDER_COMPLETED.
Returnable Items: The order must contain items that are eligible for return.
 * input-parameters: orderHeader.orderId, partyId, returnHeaderTypeId, needsInventoryReceive
 */
